import { render, staticRenderFns } from "./CarouselEffectFade.vue?vue&type=template&id=cf8d991c&"
import script from "./CarouselEffectFade.vue?vue&type=script&lang=js&"
export * from "./CarouselEffectFade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports